export class Sended {
    public isSuccessful: boolean;
    public text: string;

    constructor(isSuccessful: boolean, text: string)
    {
        this.isSuccessful = isSuccessful;
        this.text = text;
    }
}